import script from "./NotificationEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationEntry.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationEntry.vue?vue&type=style&index=0&id=b6307d84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6307d84"]])

export default __exports__